import type { Context } from 'react';
import { createContext, useContext } from 'react';

export const ExternalLinkScreenreaderSuffixContext: Context<string | undefined> = createContext<string | undefined>(
  undefined
);

type UseExternalLinkScreenreaderSuffixContext = () => string | undefined;
export const useExternalLinkScreenreaderSuffixContext: UseExternalLinkScreenreaderSuffixContext = () =>
  useContext(ExternalLinkScreenreaderSuffixContext);
